package com.essntl.features.task.ui.addedittask

import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.task.domain.model.TaskModel

sealed interface AddEditTaskEvent {
    data class UpdateTaskFields(val task: TaskModel) : AddEditTaskEvent
    data object AddTask : AddEditTaskEvent
    data object EditTask : AddEditTaskEvent
    data class GetTask(val taskId: String) : AddEditTaskEvent
    data class GetItinerary(val itineraryId: ItineraryModel, val proposalId: String) : AddEditTaskEvent
    data class GetItineraryService(val itineraryServiceId: String) : AddEditTaskEvent
    data class GetProposal(val proposalId: String) : AddEditTaskEvent
    data object ClearSuccessState : AddEditTaskEvent
    data object ClearTaskState : AddEditTaskEvent
    data object LoadMoreProfiles : AddEditTaskEvent
}